import { Card } from "@/components/ui/card";
import { Quote, Building2 } from "lucide-react";

const PartnerSignals = () => {
  // Section 1: Partner Logos
  const partnerLogos = [
    { 
      name: "UNICEF", 
      logo: "https://customer-assets.emergentagent.com/job_48bcd539-ef2e-44cd-bd5d-721585fa8242/artifacts/z4xqw9d9_image.png"
    },
    { 
      name: "The Nudge Foundation", 
      logo: "https://customer-assets.emergentagent.com/job_48bcd539-ef2e-44cd-bd5d-721585fa8242/artifacts/b5obmbkc_image.png"
    },
    { 
      name: "Change Engine", 
      logo: "https://customer-assets.emergentagent.com/job_48bcd539-ef2e-44cd-bd5d-721585fa8242/artifacts/2zfulvzp_image.png"
    },
    { 
      name: "IIM Bangalore", 
      logo: "https://customer-assets.emergentagent.com/job_48bcd539-ef2e-44cd-bd5d-721585fa8242/artifacts/r3osr2zt_image.png"
    }
  ];

  // Section 2: Partner Quotes (Finnovate-style testimonial cards) - Updated sequence
  const partnerQuotes = [
    {
      quote: "Working with a care-leaver-led organisation brings authenticity to the program design. The team understands the ground reality firsthand.",
      role: "Foundation Director",
      org: "Social Impact Partner"
    },
    {
      quote: "The program design was structured, reporting was committee-ready, and implementation aligned well with state-level aftercare frameworks.",
      role: "CSR Program Manager",
      org: "Corporate Partner"
    },
    {
      quote: "The CLiC ID system and digital tracking gave us confidence in beneficiary verification and outcome measurement.",
      role: "Program Head – Grants",
      org: "Institutional Funder"
    }
  ];

  return (
    <section className="py-12 md:py-16 bg-[#4FB6A6]/10" data-testid="partner-signals-section">
      <div className="container mx-auto px-4 lg:px-8">
        <div className="max-w-4xl mx-auto">
          
          {/* SECTION 1: Institutional & Ecosystem Partners (Logos) */}
          <div className="text-center mb-10">
            <h2 className="font-display text-xl md:text-2xl font-bold text-[#4A4A4A] mb-2">
              Institutional & Ecosystem Partners
            </h2>
          </div>

          {/* Logos Row - Muted, Single Row */}
          <div className="flex flex-wrap justify-center items-center gap-8 md:gap-12 mb-6">
            {partnerLogos.map((partner, index) => (
              <div key={index} className="flex items-center justify-center">
                <img 
                  src={partner.logo} 
                  alt={partner.name}
                  className="h-10 md:h-12 w-auto object-contain grayscale opacity-60 hover:grayscale-0 hover:opacity-100 transition-all"
                />
              </div>
            ))}
          </div>

          {/* Government Engagement Statement - Text Only, Subtle */}
          <div className="flex items-center justify-center gap-2 mb-12">
            <Building2 className="w-4 h-4 text-[#6B7280]" />
            <p className="text-sm text-[#6B7280] text-center">
              Formally invited by <span className="font-semibold text-[#4A4A4A]">13 State Governments</span> and the Central Government to support the design of care-leaver databases and aftercare systems.
            </p>
          </div>

          {/* SECTION 2: What Partners Say (Quotes) */}
          <div className="text-center mb-8">
            <h3 className="font-display text-xl font-bold text-[#4A4A4A] mb-2">
              What Partners Say
            </h3>
            <p className="text-[#6B7280] text-sm">
              Perspectives from organisations who have worked with CLiC.
            </p>
          </div>

          {/* Quote Cards - Finnovate Style */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {partnerQuotes.map((item, index) => (
              <Card 
                key={index}
                className="p-5 border-0 shadow-sm bg-white"
                data-testid={`partner-quote-${index}`}
              >
                <Quote className="w-6 h-6 text-[#1F7A5A]/20 mb-3" />
                <p className="text-[#4A4A4A] text-sm leading-relaxed mb-4">
                  "{item.quote}"
                </p>
                <div className="pt-3 border-t border-[#E5E7EB]">
                  <p className="font-medium text-[#4A4A4A] text-sm">{item.role}</p>
                  <p className="text-[#9CA3AF] text-xs">{item.org}</p>
                </div>
              </Card>
            ))}
          </div>

        </div>
      </div>
    </section>
  );
};

export default PartnerSignals;
